import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Card, CardHeader, CardText, CardTitle } from 'material-ui/Card';

import Divider from 'material-ui/Divider';
import DetailView from '../Common/DetailView';
import DeleteIcon from 'material-ui/svg-icons/action/delete';
import EditIcon from 'material-ui/svg-icons/editor/mode-edit';
import EmailTemplateIcon from 'material-ui/svg-icons/content/drafts';

import { statusColours } from '../../constants/ColourConstants';

import EmailTemplateStore from '../../stores/EmailTemplateStore';
import EmailTemplateActions from '../../actions/EmailTemplateActionCreator';

import ROLES from '../../constants/Roles';
import buildContextMenu from '../Common/BuildContextMenu';

const style = {
    icon: {
        height: '32px',
        width: '32px',
    }
};

const getMenuItems = ({id}) => [
    {
        link: `/dashboard/email/template/${id}/edit`,
        icon: <EditIcon />,
        label: 'Edit',
        condition: {
            roles: [ROLES.ADMIN]
        }
    },
    {
        link: `/dashboard/email/template/${id}/delete`,
        icon: <DeleteIcon />,
        label: 'Delete',
        condition: {
            roles: [ROLES.ADMIN]
        }
    }
];

class EmailTemplate extends Component {

    constructor() {
        super(...arguments);
        this.state = {
            details: {
                id: '',
                name: '',
                description: '',
                subject: '',
                body: '',
                notificationSubject: '',
                notificationBody: '',
                type: '',
            },
            actions: null,
        };
    }

    componentDidMount() {
        this.onChange = this.onChange.bind(this);
        this.listener = EmailTemplateStore.addListener(this.onChange);
        EmailTemplateActions.getById(Number(this.props.routeParams.id));
    }

    componentWillUnmount() {
        this.listener.remove();
    }

    render () {
        const { actions, details } = this.state;
        const { links } = this.props;

        return(

            <DetailView
                title=''
                backButton={true}
                backTo={links.back}
                actions={actions}
            >
                <div className="cent-cards">
                    <Card className="cent-card">
                        <CardHeader
                            title={details.name}
                            subtitle={details.typeName}
                            avatar={<EmailTemplateIcon style={style.icon} color={statusColours['default']}/>}
                        />
                        <CardText>
                            <div className='cent-flex-row'>
                                <div className='cent-col-2'>
                                    <ul className="cent-list-plain">
                                        <li><em>Subject: </em>{details.subject}</li>
                                    </ul>
                                </div>
                                <div className='cent-col-2'>
                                </div>
                            </div>
                        </CardText>
                        <CardText>
                            {details.body.split('\n').map((item, key) => <p key={key}>{item}</p>)}
                        </CardText>
                        {(details.notificationSubject || details.notificationBody) && (
                            <section>
                                <Divider />
                                <CardTitle subtitle="Admin notification" />
                                <CardText>
                                    <div className='cent-flex-row'>
                                        <div className='cent-col-2'>
                                            <ul className="cent-list-plain">
                                                <li><em>Subject: </em>{details.notificationSubject}</li>
                                            </ul>
                                        </div>
                                    </div>
                                    {details.notificationBody.split('\n').map((item, key) => <p key={key}>{item}</p>)}
                                </CardText>

                            </section>
                        )}
                    </Card>
                </div>
            </DetailView>
        );
    }

    onChange(){
        const details = EmailTemplateStore.getById(this.props.routeParams.id);
        if (details !== undefined) {
            let changes = {details};
            if (!!details.canEdit) {
                changes.actions = buildContextMenu(getMenuItems(this.props.routeParams), this.context.auth);
            }
            this.setState(changes);
        }
    }
}

EmailTemplate.contextTypes = {
    auth: PropTypes.object.isRequired
};

EmailTemplate.propTypes = {
    links: PropTypes.shape({
        back: PropTypes.string
    })
};

EmailTemplate.defaultProps = {
    links: {
        back: '/dashboard/email/templates',
    }
};

export default EmailTemplate;
